import { cssVarColors, cssVarTextColors } from 'lib/cssSelector'
import { Styles } from 'react-jss'

const { placeholder, main } = cssVarTextColors
const { contentBg, mainLightHover, mainActive, error, background, border } = cssVarColors
const defaultBorder = (color: string) => `1px solid ${color}`

export const fieldStatusAppearence = {
  text: {
    color: main,
    fontSize: 15,
    fontWeight: 400
  },
  base: {
    border: defaultBorder(border),
    backgroundColor: background,
    borderRadius: '4px',
    boxSizing: 'border-box',
    width: '-webkit-fill-available',
    justifyContent: 'center'
  },
  success: {
    border: defaultBorder('#00AE23')
  },
  focused: {
    outlineColor: mainActive,
    border: defaultBorder(mainActive)
  },
  disabled: {
    outlineColor: 'none',
    border: defaultBorder(mainLightHover)
  },
  error: {
    border: defaultBorder(error),
    outlineColor: error
  },
  placeholder: {
    color: placeholder,
    fontSize: 15,
    fontFamily: 'Poppins'
  }
}

export const fieldsClasses: Styles = {
  inputRoot: {},
  calendar: {},
  inputRow: {
    width: '100%',
    position: 'relative',
    '& > $inputRoot': {
      position: 'relative',
      '& $calendar': {
        color: '#dc233b !important'
      }
    }
  },
  inputControl: {
    display: 'block',
    minWidth: 100,
    width: '100%',
    fontFamily: 'Poppins',
    ...fieldStatusAppearence.text,
    ...fieldStatusAppearence.base,

    padding: '12px 15px',
    '&:focus, &:active': {
      ...fieldStatusAppearence.focused
    },
    '&::placeholder': {
      ...fieldStatusAppearence.placeholder
    }
  },
  disabled: {
    '&:focus, &:active': {
      ...fieldStatusAppearence.disabled
    }
  },

  wrapper: {
    marginBottom: '10px'
  },
  fieldWrapper: {
    display: 'flex',
    '& > *': {
      width: 130
    },
    '& > *:not(:first-child)': {
      marginLeft: 10
    }
  },
  passwordIcon: {
    position: 'absolute',
    bottom: '30%',
    top: '50%',
    transform: 'translateY(-50%)',
    right: '3%',
    cursor: 'pointer'
  },
  inputBorder: {
    ...fieldStatusAppearence.success
  },
  textAreaControl: {
    fontFamily: 'Poppins',
    resize: 'none',
    display: 'block',
    minWidth: 100,
    width: '100%',
    lineHeight: '20px',
    padding: 10,
    ...fieldStatusAppearence.text,
    ...fieldStatusAppearence.base,
    '&:focus, &:active': {
      ...fieldStatusAppearence.focused
    }
  },
  paddingInput: {
    paddingLeft: 40
  },
  iconInput: {
    position: 'absolute',
    top: '15%',
    left: '2%'
  },
  inputControlError: {
    ...fieldStatusAppearence.error,
    '&:focus, &:active': {
      ...fieldStatusAppearence.error
    }
  },
  iconDP: {
    position: 'absolute',
    top: 15,
    right: 10
  },
  noBorder: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 40,
    lineHeight: '66px',
    color: '#080910',
    border: 'none',
    boxShadow: 'none',
    backgroundColor: 'inherit',
    paddingRight: '2em',
    '&:focus, &:active': {
      outlineColor: 'none',
      border: 'none'
    },
    '&::placeholder': {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 40,
      lineHeight: '66px',
      color: '#E6E6E6'
    }
  },
  rightIcon: {
    position: 'absolute',
    right: 10,
    top: 'calc(50% - 7px)',
    width: '14px',
    height: '14px'
  }
}
